module.exports = __webpack_public_path__ + "static/media/courseLabel.ce7aa99c.svg";